import { PendingActivitiesPerProfessionalItem } from 'domain/models';
import { useState } from 'react';
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Badge,
  Table,
} from 'reactstrap';

interface IProps {
  items: PendingActivitiesPerProfessionalItem[];
}

export const PendingActivitiesProfessionalAccordion = ({ items }: IProps) => {
  const [openItemId, setOpenItemId] = useState<string>('');

  const handleToggle = (itemId: string) => {
    setOpenItemId((prevState) => (prevState === itemId ? '' : itemId));
  };

  return (
    <Accordion open={openItemId} toggle={handleToggle}>
      {items.map((item) => (
        <AccordionItem key={item.professionalHashId}>
          <AccordionHeader targetId={item.professionalHashId}>
            <div className="w-100 d-flex flex-wrap align-items-center justify-content-between gap-2 pe-3">
              <div className="d-flex align-items-center gap-2">
                {item.professionalPhoto ? (
                  <img
                    src={item.professionalPhoto}
                    alt={item.professionalName}
                    width={36}
                    height={36}
                    className="rounded-circle object-fit-cover"
                  />
                ) : (
                  <div
                    className="rounded-circle bg-light d-flex align-items-center justify-content-center"
                    style={{ width: 36, height: 36 }}
                  >
                    <i className="ri-user-3-line text-muted" />
                  </div>
                )}
                <strong>{item.professionalName}</strong>
              </div>

              <div className="d-flex flex-wrap align-items-center gap-2">
                <Badge color="primary" pill>
                  Atividades: {item.pendingActivitiesCount}
                </Badge>
                <Badge color="info" pill>
                  Exclusivas: {item.exclusiveWorkloadHours}h
                </Badge>
                <Badge color="warning" pill>
                  Compartilhadas: {item.sharedWorkloadHours}h
                </Badge>
              </div>
            </div>
          </AccordionHeader>

          <AccordionBody accordionId={item.professionalHashId}>
            <Table responsive bordered hover className="align-middle mb-0">
              <thead>
                <tr>
                  <th rowSpan={2} className="text-center">
                    Grupo
                  </th>
                  <th colSpan={2} className="text-center">
                    Exclusivas
                  </th>
                  <th colSpan={2} className="text-center">
                    Compartilhadas
                  </th>
                </tr>
                <tr>
                  <th className="text-center">Quantidade</th>
                  <th className="text-center">Carga Horária</th>
                  <th className="text-center">Quantidade</th>
                  <th className="text-center">Carga Horária</th>
                </tr>
              </thead>
              <tbody>
                {item.groups.map((group) => (
                  <tr key={group.groupName}>
                    <td className="text-center">{group.groupName}</td>
                    <td className="text-center">
                      {group.exclusiveActivitiesCount}
                    </td>
                    <td className="text-center">
                      {group.exclusiveWorkloadHours}h
                    </td>
                    <td className="text-center">
                      {group.sharedActivitiesCount}
                    </td>
                    <td className="text-center">
                      {group.sharedWorkloadHours}h
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </AccordionBody>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
